/**
 * ConfigService implementation that reads from Vite environment variables.
 * All env vars must be prefixed with VITE_ to be exposed to client code.
 */

import type { ConfigService } from "./config.types";
import type { Config } from "./config.types";
import { parseFeatureFlags, buildFeatures } from "@/feature-flags/feature-flags";

function getAllowedRedirectDomains(): string[] {
	const raw = import.meta.env.VITE_REDIRECTION_ALLOWED_DOMAINS ?? "";
	return raw
		.split(",")
		.map((domain: string) => domain.trim())
		.filter(Boolean);
}

function getRedirectDefaultUrl(): string {
	return import.meta.env.VITE_REDIRECTION_DEFAULT_RETURNURL ?? "";
}

function getFeatures(): Config["features"] {
	const raw = import.meta.env.VITE_FEATURE_MANAGEMENT;
	return buildFeatures(parseFeatureFlags(raw));
}

/**
 * Config service that resolves config from import.meta.env (Vite env).
 */
export class EnvConfigService implements ConfigService {
	getConfig(): Config {
		return {
			apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? "/api",
			recaptchaSiteKey: import.meta.env.VITE_RECAPTCHA_SITE_KEY ?? "",
			allowedRedirectDomains: getAllowedRedirectDomains(),
			redirectDefaultUrl: getRedirectDefaultUrl(),
			features: getFeatures(),
		};
	}
}
